/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag, BcsFlag } from "../unleash";

const BcsPermissionMedusa = {
  client_id_courrier_recommendation_config: new BcsFlag.NumberFlag(0),
  flag_booking_woodpacking_enable_for_malaysia: new BcsFlag.StringFlag("v2")
}

const FcsPermissionMedusa = {
  config_new_cod_booking_enable: new FcsFlag.Flag(false),
  config_max_address: new FcsFlag.NumberFlag(200),
  permission_woodpacking_shipment: new FcsFlag.Flag(false),
  flag_release_interpack_additional_info: new FcsFlag.Flag(false),
  permission_login_2fa_enable: new FcsFlag.Flag(false),
  permission_hq_country_filter_enable: new FcsFlag.Flag(false)
}

const RoxPermissionMedusa = {
  banner_bni_kur_enable: new Rox.Flag(false),
  config_cod_ongkir_enable: new Rox.Flag(false),
  config_modify_courier_enable: new Rox.Flag(false),
  config_timeout_ngen_booking: new Rox.RoxNumber(22000),
  config_new_receipt: new Rox.Flag(false),
  config_extra_receipt: new Rox.Flag(false),
  config_max_generate_manual_stt: new Rox.RoxNumber(5000),
  config_commodity_general_others_id: new Rox.RoxNumber(499),
  config_commodity_general_others_code: new Rox.RoxString("GEN"),
  config_commodity_general_others_name: new Rox.RoxString(
    "GENERAL OTHERS - GENERAL LAINNYA"
  ),
  config_volumetric_weight_sikat: new Rox.RoxNumber(3),
  config_pos_affiliate_banner: new Rox.Flag(false),
  config_claim_riwayat_pengiriman: new Rox.Flag(false),
  config_claim_pengiriman_aktif: new Rox.Flag(false),
  flag_booking_woodpacking_enable: new Rox.Flag(false),
  config_pos_performance_dashboard: new Rox.RoxString(""),
  config_id_whitelist_payment_qris_booking: new Rox.RoxString("ALL"),
  config_id_whitelist_payment_qris_tagihan: new Rox.RoxString("ALL"),
  config_enable_payment_qris: new Rox.Flag(false),
  config_loan_ocbc: new Rox.Flag(false),
  all_prefix_shipments: new Rox.RoxString(""),
  prefix_shipment_dimension_disable: new Rox.RoxString(""),
  config_allowance_adjustment_weight_tklp: new Rox.RoxString(""),
  custom_status_halcd: new Rox.Flag(false),
  config_volumetric_by_product: new Rox.RoxString("{}"),
  cod_dfod_pos_favorite: new Rox.Flag(false),
  user_whitelist_for_edit_shipment_c1: new Rox.RoxString(""),
  config_version_endpoint_withdraw_pos: new Rox.RoxString("v1"),
  config_auto_checkbox_cod_pos: new Rox.Flag(false),
  config_table_v2_batch_threshold: new Rox.RoxNumber(100),
  config_table_v2_batch_size: new Rox.RoxNumber(100),
  flag_sidebar_menu_feedback: new Rox.Flag(false),
  flag_auto_show_popup_feedback: new Rox.Flag(false),
  config_days_appear_feedback: new Rox.RoxNumber(3),
  config_banner_url_insurance_booking_retail: new Rox.RoxString("https://dev-genesis.s3.ap-southeast-1.amazonaws.com/new-banner-insurance.png"),
  config_blacklist_account_genesis: new Rox.Flag(false),
  config_is_assigned_3lc: new Rox.Flag(false),
  information_running_text: new Rox.RoxString(
    [
      "COD Ongkir di Lion Parcel, Gak Bayar Ongkir Kalau Telat!❤️",
      "Kirim Paket di Bawah 10 Kg Pakai BIGPACK, Diskon 20%!👌",
      "COD Ongkir di Lion Parcel, Gak Bayar Ongkir Kalau Telat!😱"
    ].join(" | ")
  ),
  config_default_viewport_scale: new Rox.RoxNumber(1.0),
  config_max_volume_weight: new Rox.RoxNumber(0),
  // device auth flags
  config_device_auth_enable: new Rox.Flag(false),
  config_device_auth_pooling_rate: new Rox.RoxNumber(3000),
  config_device_auth_auto_approval_delay: new Rox.RoxNumber(3000),
}

export const FlagsMedusa = {
  ...RoxPermissionMedusa,
  ...FcsPermissionMedusa,
  ...BcsPermissionMedusa
};

export function initFlagsMedusa() {
  // register flags with namespaces for better grouping
  Rox.register("medusa", RoxPermissionMedusa);
  FcsFlag.register("medusa", FcsPermissionMedusa);
  BcsFlag.register("medusa", BcsPermissionMedusa);
}
